import { defineStore } from 'pinia';
import ServiceExec, { customToast } from '@/common/utils/ServiceExec';
import { adminoperate } from '@/common/service/api/apiList';
import { HttpStatusCode } from 'axios';
import { toastAlert } from '@/common/utils/module/ToastSupport';
import { asFormData } from '@/common/utils/module/FormDataSupport';
import { cloneDeep } from 'lodash';

export const useOperateStore = defineStore('operate', {
  state: () => ({
    list: [],
    excelList: [],
    pageInfo: {},
    detail: {},
    menu: {}
  }),
  getters: {},
  actions: {
    async deleteBoard(params) {
      const { status, data } = await ServiceExec.delete(adminoperate.deleteBoard, params);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async saveBoard(params) {
      const { status, data } = await ServiceExec.post(adminoperate.saveBoard, params);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async getBoardList(params, isExcel = false) {
      const { status, data } = await ServiceExec.get(adminoperate.getBoardList, params);
      await this.setList(status, data, isExcel);
    },
    async getBoard(boardNo) {
      const { status, data } = await ServiceExec.get(adminoperate.getBoard(boardNo));
      if (status === ServiceExec.status.OK) await this.setDetail(data);
    },
    async getInquiry(payload) {
      const { status, data } = await ServiceExec.get(adminoperate.getInquiry(payload.inquiryNo));
      if (status === ServiceExec.status.OK) await this.setDetail(data);
    },
    async deleteInquiry(params) {
      const { status, data } = await ServiceExec.delete(adminoperate.deleteInquiry, params);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async getInquiryList(params, isExcel = false) {
      const { status, data } = await ServiceExec.get(adminoperate.getInquiryList, params);
      await this.setList(status, data, isExcel);
    },
    async updateInquiryAnswer(params) {
      console.log(params.inquiryNo);
      const { status, data } = await ServiceExec.patch(adminoperate.updateInquiryAnswer(params.inquiryNo), params);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },

    async getBannerList(params) {
      const { status, data } = await ServiceExec.get(adminoperate.getBannerList, params);
      this.list = data;
      this.pageInfo = {
        page: 1,
        pageBlock: 1,
        rowPerPage: 10,
        pagePerBlock: 10,
        totalRow: data.length,
        virtualNum: data.length,
        totalPage: 1,
        totalBlock: 1,
        startPage: 1,
        endPage: 1,
        isPrevBlock: 0,
        isNextBlock: 0,
        startIdx: 0
      };
    },
    async deleteBanner(params) {
      const { status, data } = await ServiceExec.delete(adminoperate.deleteBanner, params);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async saveBanner(params) {
      const copyParams = cloneDeep(params);
      const payload = asFormData(copyParams);
      const { status, data } = await ServiceExec.multipart(adminoperate.saveBanner, 'POST', payload);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async getBanner(bannerNo) {
      const { status, data } = await ServiceExec.get(adminoperate.getBanner(bannerNo));
      if (status === ServiceExec.status.OK) await this.setDetail(data);
    },

    async updateMenuOperate(params) {
      const { status, data } = await ServiceExec.patch(adminoperate.updateMenuOperate, params);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async getMenuOperate() {
      const { status, data } = await ServiceExec.get(adminoperate.getMenuOperate);
      this.menu = data;
    },
    async getPushList(params, isExcel = false) {
      const { status, data } = await ServiceExec.get(adminoperate.getPushList, params);
      console.log(data);
      await this.setList(status, data, isExcel);
    },
    async getPush(pushNo) {
      const { status, data } = await ServiceExec.get(adminoperate.getPush(pushNo));
      if (status === ServiceExec.status.OK) await this.setDetail(data);
    },
    async savePush(params) {
      const { status, data } = await ServiceExec.post(adminoperate.savePush, params);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async sendPush(pushNo) {
      const { status, data } = await ServiceExec.patch(adminoperate.sendPush(pushNo));
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async deletePush(params) {
      const { status, data } = await ServiceExec.delete(adminoperate.deletePush, params);
      if (status !== ServiceExec.status.OK) return false;
      return true;
    },
    async setList(status, data, isExcel = false) {
      if (status !== HttpStatusCode.Ok) {
        await toastAlert(data.message, 'error');
        return;
      }
      if (!isExcel) {
        this.list = data.list;
        this.pageInfo = data.pageInfo;
      } else {
        this.excelList = data.list;
      }
    },
    async setDetail(data = {}) {
      this.detail = data;
    }
  }
});
